import {
  HttpPromiseFulfilledState,
  HttpPromisePendingState,
  HttpPromiseRejectedState,
  HttpPromiseResolvedState,
  HttpPromiseState,
} from './HttpPromiseState';
import {
  PromiseFulfilledState,
  PromisePendingState,
  PromiseRejectedState,
  PromiseResolvedState,
  PromiseState
} from './PromiseState';

/**/
function reject<T>(error: any): PromiseRejectedState<T> {
  return {
    state: 'rejected',
    error: error,
    value: null,
    isPending: false,
    isCompleted: true,
    isResolved: false,
    isRejected: true
  };
}

function pending<T>(): PromisePendingState<T> {
  return {
    state: 'pending',
    error: null,
    value: null,
    isPending: true,
    isCompleted: false,
    isResolved: false,
    isRejected: false
  };
}

function resolve<T>(value: T): PromiseResolvedState<T> {
  return {
    state: 'resolved',
    error: null,
    value: value,
    isPending: false,
    isCompleted: true,
    isResolved: true,
    isRejected: false
  };
}

class PromiseStateBuilderClass {
  readonly reject = reject;
  readonly pending = pending;
  readonly resolve = resolve;
}

/**/
function isPending<T>(arg: PromiseState<T> | null): arg is PromisePendingState<T>;
function isPending<T>(arg: HttpPromiseState<T> | null): arg is HttpPromisePendingState<T>;
function isPending<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromisePendingState<T> | HttpPromisePendingState<T>);
function isPending<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromisePendingState<T> | HttpPromisePendingState<T>) {
  return arg?.isPending === true;
}


function isResolved<T>(arg: PromiseState<T> | null): arg is PromiseResolvedState<T>;
function isResolved<T>(arg: HttpPromiseState<T> | null): arg is HttpPromiseResolvedState<T>;
function isResolved<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromiseResolvedState<T> | HttpPromiseResolvedState<T>);
function isResolved<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromiseResolvedState<T> | HttpPromiseResolvedState<T>) {
  return arg?.isResolved === true;
}


function isRejected<T>(arg: PromiseState<T> | null): arg is PromiseRejectedState<T>;
function isRejected<T>(arg: HttpPromiseState<T> | null): arg is HttpPromiseRejectedState<T>;
function isRejected<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromiseRejectedState<T> | HttpPromiseRejectedState<T>);
function isRejected<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromiseRejectedState<T> | HttpPromiseRejectedState<T>) {
  return arg?.isRejected === true;
}


function isCompleted<T>(arg: PromiseState<T> | null): arg is PromiseFulfilledState<T>;
function isCompleted<T>(arg: HttpPromiseState<T> | null): arg is HttpPromiseFulfilledState<T>;
function isCompleted<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromiseFulfilledState<T> | HttpPromiseFulfilledState<T>);
function isCompleted<T>(arg: HttpPromiseState<T> | PromiseState<T> | null):
  arg is (PromiseFulfilledState<T> | HttpPromiseFulfilledState<T>) {
  return arg?.isCompleted === true;
}

class PromiseStatesClass {
  readonly b = new PromiseStateBuilderClass();

  readonly isPending = isPending;
  readonly isResolved = isResolved;
  readonly isRejected = isRejected;
  readonly isCompleted = isCompleted;
}

export const promiseStates = new PromiseStatesClass();
